import { render, staticRenderFns } from "./SpecialPages.vue?vue&type=template&id=66b06755"
import script from "./SpecialPages.vue?vue&type=script&lang=js"
export * from "./SpecialPages.vue?vue&type=script&lang=js"
import style0 from "./SpecialPages.vue?vue&type=style&index=0&id=66b06755&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports